import { Feature, Geometry } from 'geojson';
import { BuildingBorder } from 'src/app/geometrics-form/building-borders/state/building-border.model';
import { Building } from 'src/app/geometrics-form/buildings/state/building.model';
import { Edge } from 'src/app/geometrics-form/edges/state/edge.model';
import { Vertex } from 'src/app/geometrics-form/vertexes/state/vertex.model';

const vertexToFeature = (vertex: Vertex): Feature<Geometry, { [name: string]: any; }> => {
  return {
    type: 'Feature',
    id: vertex.id,
    geometry: {
      type: 'Point',
      coordinates: [
        vertex.longitude,
        vertex.latitude
      ]
    },
    properties: vertex
  };
};

const edgeToFeature = (edge: Edge): Feature<Geometry, { [name: string]: any; }> => {
  return {
    type: 'Feature',
    id: edge.id,
    geometry: {
      type: 'LineString',
      coordinates: [
        [edge.va_longitude, edge.va_latitude],
        [edge.vb_longitude, edge.vb_latitude]
      ]
    },
    properties: edge
  };
};

const BUILDING_SPACE = 0.000025;

const buildingToFeature = (building: Building): Feature<Geometry, { [name: string]: any; }> => {
  const centerA = [building.longitude + BUILDING_SPACE, building.latitude + BUILDING_SPACE];
  const centerB = [building.longitude - BUILDING_SPACE, building.latitude - BUILDING_SPACE];
  return {
    type: 'Feature',
    id: building.id,
    geometry: {
      type: 'LineString',
      coordinates: [centerA, centerB]
    },
    properties: {
      ...building,
      // Nested elements not work in MapBox
      occupancy: building.properties?.occupancy,
      orientation: building.properties?.orientation,
      units: calcule_units(building)
    }
  };
};

const buildingVertexToFeature = (building: Building): Feature<Geometry, { [name: string]: any; }> => {
  const centerA = [building.longitude, building.latitude];
  const centerB = [building.vertex_longitude, building.vertex_latitude];
  return {
    type: 'Feature',
    id: building.id,
    geometry: {
      type: 'LineString',
      coordinates: [centerA, centerB]
    },
    properties: building
  };
};

const buildingBorderToFeature = (buildingBorder: BuildingBorder): Feature<Geometry, { [name: string]: any; }> => {
  return {
    type: 'Feature',
    id: buildingBorder.id,
    geometry: {
      type: 'Point',
      coordinates: [
        buildingBorder.longitude,
        buildingBorder.latitude
      ]
    },
    properties: buildingBorder
  };
};

function calcule_units(building: Building) {

  const { properties } = building;

  if (properties.occupancy === 'Individual') {
    return null;
  }

  if (properties.orientation === 'Horizontal') {
    if (properties.type === 'Residential') {
      return properties.residential_units;
    }
    if (properties.type === 'NonResidential') {
      return properties.nonresidential_units;
    }
    return properties.residential_units + properties.nonresidential_units;

  }

  return properties.blocks.reduce((previous, block, index, array) => {
    if (properties.type === 'Residential') {
      return previous + block.residential_units;
    } else if (properties.type === 'NonResidential') {
      return previous + block.nonresidential_units;
    } else {
      return previous + properties.residential_units + properties.nonresidential_units;
    }
  }, 0);

}


export {
  vertexToFeature,
  edgeToFeature,
  buildingToFeature,
  buildingVertexToFeature,
  buildingBorderToFeature
};
